import { updateDeviceIncidentsReducer } from "fleet/redux-store/ui-state/device-incidents/reducers";
import {
  LOAD_INCIDENTS_SUCCESS,
  UNLOAD_INCIDENTS,
  RESOLVE_INCIDENT_SUCCESS,
} from "fleet/redux-store/ui-state/incidents/actions";
import { defaultArray } from "redux-store/selectors";

const initialState = {
  incidents: defaultArray,
  statusCode: null,
};

function incidentsReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case LOAD_INCIDENTS_SUCCESS:
      return {
        incidents: payload.data,
        statusCode: payload.response.status,
      };
    case RESOLVE_INCIDENT_SUCCESS:
      return updateDeviceIncidentsReducer(state, action);
    case UNLOAD_INCIDENTS:
      return initialState;
    default:
      return state;
  }
}

export { incidentsReducer };
